var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      class: { is_hover: _vm.isHover, is_fixed: _vm.isFixed },
      attrs: { id: "toast_header" },
      on: {
        mouseover: function($event) {
          _vm.hoverGnb(true)
        },
        mouseout: function($event) {
          _vm.hoverGnb(false)
        }
      }
    },
    [
      !_vm.isMobile ? _c("web-optimum-alarm") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner" },
        [
          _c("gnb-logo", {
            attrs: {
              showToastLogo: _vm.showToastLogo,
              toastLogo: _vm.toastLogo,
              logo: _vm.logo,
              isDefaultSetting: _vm.isDefaultSetting
            }
          }),
          _vm._v(" "),
          _vm.isMobile
            ? _c("gnb-header-menu-mobile", {
                attrs: {
                  gnbMenus: _vm.computedGnbMenus,
                  enableUserMenu: _vm.enableUserMenu
                }
              })
            : _c("gnb-header-menu", {
                attrs: { gnbMenus: _vm.computedGnbMenus }
              }),
          _vm._v(" "),
          _c("gnb-header-side-menu", {
            attrs: {
              isDefaultSetting: _vm.isDefaultSetting,
              enableSearch: _vm.enableSearch,
              enableChangeLocale: _vm.enableChangeLocale,
              enableUserMenu: _vm.enableUserMenuForSideMenu,
              joinButton: _vm.joinButton,
              enableNewsletter: _vm.isJp ? false : _vm.enableNewsletter
            }
          }),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "button",
                {
                  staticClass: "btn_gnb",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.setShowGnb(!_vm.showGnb)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("gnb.toggle-show-gnb")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }